/* Restore the existing hero/solid presentation boundary without touching native controls. */
if(!customElements.get('rp-v2-header-bridge'))customElements.define('rp-v2-header-bridge',class extends HTMLElement{
 connectedCallback(){
  if(this.controller)return;
  this.controller=new AbortController();const signal=this.controller.signal;
  this.root=this.closest('.section-header');if(!this.root)return;
  this.queue=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.update();});};
  this.stateObserver=new MutationObserver(this.queue);this.stateObserver.observe(this.root,{attributes:true,attributeFilter:['class']});
  this.mount=()=>{
   this.hero=this.dataset.rpV2Home==='true'?document.querySelector('.rp-v2-hero'):null;
   this.observer?.disconnect();
   if(this.hero){this.observer=new IntersectionObserver(this.queue,{threshold:[0,1]});this.observer.observe(this.hero);}
   const actions=this.root.querySelector('.header__icons');const template=this.querySelector('[data-rp-v2-header-cta]');
   if(actions && template && !this.cta){this.cta=template.content.firstElementChild.cloneNode(true);actions.append(this.cta);}
   this.update();
  };
  document.addEventListener('shopify:section:load',this.mount,{signal});
  document.addEventListener('DOMContentLoaded',this.mount,{signal});
  window.addEventListener('scroll',this.queue,{signal,passive:true});window.addEventListener('resize',this.queue,{signal,passive:true});
  this.mount();
 }
 update(){
  if(!this.root)return;const rect=this.hero?.getBoundingClientRect();
  const onHero=rect && !this.root.classList.contains('shopify-section-header-sticky') && rect.bottom>Math.max(80,this.root.getBoundingClientRect().height) && rect.top<innerHeight;
  const state=onHero?'hero':'solid';if(this.root.dataset.rpV2HeaderState!==state)this.root.dataset.rpV2HeaderState=state;
 }
 disconnectedCallback(){this.controller?.abort();this.controller=null;this.observer?.disconnect();this.stateObserver?.disconnect();cancelAnimationFrame(this.frame);this.frame=0;this.cta?.remove();this.cta=null;this.root?.removeAttribute('data-rp-v2-header-state');this.root=null;this.hero=null;}
});
